import { Component, Inject } from '@angular/core';
import { MfDocComponent } from '../mf-doc/mf-doc.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-mf-preview',
  templateUrl: './mf-preview.component.html',
  styleUrls: ['./mf-preview.component.scss']
})

export class MfPreviewComponent {

  public sanitizedSourceArte!: SafeResourceUrl;
  archivos: any = [];

  dataWithFile: {
    preview: SafeResourceUrl,
    nombre: string
  } = {preview: '', nombre: ''};

  constructor(
      @Inject(MAT_DIALOG_DATA) public data : any,
      public sanitizer: DomSanitizer,
      private matDialog: MatDialog,
      private dialogRefPreview: MatDialogRef<MfPreviewComponent>,

    ) {
      console.log(data)
    }

    ngOnInit(): void {
      this.dataWithFile.preview = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.mf.preview);
    }

    getSourceURL(fileUrl: SafeResourceUrl): SafeResourceUrl {
        return fileUrl;
    }

    openDialogDocMf(row:any) {
      this.matDialog.open(MfDocComponent, {
        panelClass: ['dialogs-main'],
        data: {
          id_campana : this.data.id_campana,
          mf: row
        }
      }).afterClosed().subscribe(
        resp => {
          if(resp?.reload)  {
            this.dialogRefPreview.close();
          }
        }
      );
    }
  
}
